module.exports = __webpack_public_path__ + "static/media/brownSugar.fd2f12a4.jpeg";